(ns quuppa.sente.transit
  (:require  [quuppa.common.transit :as transit]
             #?(:cljs [taoensso.sente.packers.transit :as sente-transit])))

(defn transit-packer []
  ;; JIT requiring of the Sente ns. So applications without Sente can use this namespace AOT version as dep.
  (#?(:clj (requiring-resolve 'taoensso.sente.packers.transit/->TransitPacker))
    #?(:cljs sente-transit/->TransitPacker)
    transit/transit-reader-type
    ;; writer opts
    {:handlers transit/write-handlers}
    ;; reader opts
    {:handlers transit/read-handlers}))
